import { graphql } from "@/lib/gql/__generated__";

export const SalesMastList_ManagementSalesPage_Query = graphql(`
	query SalesMastList_ManagementSalesPage($hotelID: ID!, $startDate: String!, $endDate: String!) {
		salesMastList(hotelID: $hotelID, startDate: $startDate, endDate: $endDate) {
			id
			list {
				hotelID
				salesMastType
				infoReservation {
					reservationID
					guestName
					guestEmail
					guestTel
					guestPostalCode
					guestAddress
				}
				infoEC {
					userECReceiptID
					guestName
					guestEmail
					guestTel
					guestPostalCode
					guestAddress
				}
				infoTicket {
					billingHotelName
					ticketName
					validDtEnd
					validMonth
				}
				income
				commission
				card
				transferredAt
			}
		}
	}
`);
